import React, { FC } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FormInput } from "go-form";
import FormMoneyInput from "go-form/components/FormMoneyInput";
import FormNumberInput from "go-form/components/FormNumberInput";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { ProductApi } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ProductApi>;
}

const ProductAdditionalInfoForm: FC<Props> = ({ form }) => {
	const {
		formState: { errors },
		control,
		register,
	} = form;
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const currency = organization?.currency ?? "PLN";

	return (
		<fieldset className="form-group">
			<FormInput
				name="description"
				errors={errors}
				register={register}
				as="textarea"
				label={t("lib:common.word.description")}
			/>
			<div className="row">
				<div className="col-lg-10">
					<div className="row">
						<div className="col-md-6">
							<FormNumberInput
								errors={errors}
								name="weight"
								decimalScale={5}
								control={control}
								suffix=""
								label={t("modules.product.field.weight.title")}
							/>
						</div>
						<div className="col-md-6">
							<Form.Label>{t("modules.product.field.sale_price_net_money.title")}</Form.Label>
							<InputGroup className="form-input-group">
								<FormMoneyInput
									errors={errors}
									control={control}
									name="sale_price_net_money.amount"
									currency=""
								/>
								<InputGroup.Text style={{ height: "31px" }}>{currency}</InputGroup.Text>
							</InputGroup>
						</div>
					</div>
				</div>
			</div>
		</fieldset>
	);
};

export default ProductAdditionalInfoForm;
